import { ProductTypes, TakeoverType } from '~src/model';

export const showTakeover = (activeTabs: ProductTypes, takeover?: TakeoverType) => {
  if (activeTabs.length === 1 && activeTabs.includes('solar') && takeover !== 'apartment') {
    return;
  }

  return takeover;
};
